import React from 'react';

const SkeletonBlock = ({ className = '' }) => (
  <div className={`skeleton-shimmer rounded ${className}`} />
);

export const ProjectSkeleton = () => (
  <div className="space-y-4" data-testid="skeleton-project">
    <SkeletonBlock className="w-full aspect-video" />
    <SkeletonBlock className="h-4 w-1/3" />
    <SkeletonBlock className="h-6 w-2/3" />
  </div>
);

export const BentoSkeleton = () => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-testid="skeleton-bento">
    <SkeletonBlock className="aspect-video col-span-2" />
    <SkeletonBlock className="aspect-square" />
    <SkeletonBlock className="aspect-square" />
    <SkeletonBlock className="aspect-video col-span-2" />
  </div>
);

export const HeroSkeleton = () => (
  <div className="min-h-screen flex flex-col items-center justify-center px-6 py-20 space-y-8" data-testid="skeleton-hero">
    <SkeletonBlock className="h-24 w-3/4 max-w-3xl" />
    <SkeletonBlock className="h-12 w-1/2 max-w-xl" />
    <SkeletonBlock className="h-6 w-1/3 max-w-md" />
  </div>
);

export default SkeletonBlock;
